/**
 * Rebuilds the route template behind a pathname by swapping matched param
 * values back to their `:name` placeholders.
 *
 * Tagging feedback with the raw pathname would give every request and workflow
 * its own tag value, so the tag could never be grouped or filtered usefully.
 * Splat values span several segments and are left as they are.
 */
export const toRouteTemplate = (
  pathname: string,
  params: Readonly<Record<string, string | undefined>>,
) => {
  const placeholderByValue = new Map<string, string>();
  for (const [name, value] of Object.entries(params)) {
    if (value) {
      placeholderByValue.set(value, `:${name}`);
    }
  }

  return pathname
    .split('/')
    .map((segment) => placeholderByValue.get(segment) ?? segment)
    .join('/');
};
